import { useEffect, useState } from 'react';

function matches(query) {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    try {
        return window.matchMedia(query).matches;
    } catch {
        return false;
    }
}

/** Live `window.matchMedia(query).matches`; false where matchMedia is unavailable. */
export function useMediaQuery(query) {
    const [match, setMatch] = useState(() => matches(query));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        let mql;
        try {
            mql = window.matchMedia(query);
        } catch {
            return undefined;
        }
        const onChange = (event) => setMatch(!!event.matches);
        setMatch(mql.matches);
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else mql.addListener(onChange);
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange);
            else mql.removeListener(onChange);
        };
    }, [query]);

    return match;
}
